import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { AiFillReconciliation } from 'react-icons/ai';
import { useQuery } from 'react-query';
import axiosClient from 'http/axios-client';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import ConsentsTable from './consents/ConsentsTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const Concents = () => {
  const classes = useStyles();

  const {
    items: consents,
  } = useItems(CollectionKeys.CONSENTS,
    {
      filterQuery: {
        _limit: -1,
      },
    });

  const {
    data: countFiltered,
  } = useQuery(
    [ `${ CollectionKeys.REGISTRATION_KITS }`, 'COUNT', { filterQuery: { _limit: -1, doctor_null: true } }],
    () => {
      return axiosClient.get(`${ CollectionKeys.REGISTRATION_KITS }/count`, {
        params: { _limit: -1,
          doctor_null: true },
      });
    },
  );

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <AiFillReconciliation
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Registration kit management'
          subtitle={ countFiltered === undefined ? '' : `Entries: ${ countFiltered ?? 0 }` }
          actions={ (
            <>
            </>
          ) }
        />
      </div>
      <ConsentsTable
        consents={ consents }
      />
    </div>
  );
};

export default Concents;
